export default __webpack_public_path__ + "static/media/petal_SpiritualHealth.59181db5.svg";